export const COMMON_DO_LOGOUT = 'COMMON_DO_LOGOUT';
export const COMMON_COST_PROCESSING_CSV = 'COMMON_COST_PROCESSING_CSV';
export const COMMON_RESET_CSV_DATA = 'COMMON_RESET_CSV_DATA';



// WEBPACK FOOTER //
// ./src/features/common/redux/constants.js